// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, [96], () => (__webpack_require__("./src/appCode.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
